import { render, staticRenderFns } from "./SalesNoteDetail.vue?vue&type=template&id=668debf9&"
import script from "./SalesNoteDetail.vue?vue&type=script&lang=js&"
export * from "./SalesNoteDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports